import React, { useEffect, useState } from "react";
import {
  Container,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import "./FormScreen.css";
import logoSmall from "../assets/logo_small.png";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { getLocalidadById } from "../api/localidad";
import { getCategoriaEstablecimientoById } from "../api/categoriaEstablecimiento";
import { getBusinessById, getBusinessByQrId, getRatingByBusiness } from "../api/business";
import { getTipedsByBusinessId, getTipedByQrId } from "../api/tiped";
import { postTip } from "../api/tip";
import { KTCookie } from "../utils/cookie";
import { postTiper } from "../api/tiper";
import { getTasas } from "../api/tasa";
import CookieConsent from "react-cookie-consent";
import { getTextById } from "../api/text";
import { getCoinById } from "../api/coin";
import { getPaisById } from "../api/pais";
import { event } from "../utils/gtag";

function getEmptyBusiness() {
  return {
    nombre_comercial: "",
    direccion: "",
    localidad: "",
    codigo_postal: "",
    email: "",
    categoriaEstablecimiento: "",
    telefonos: [],
    entidades_tipeds: [],
    reparto: {},
  };
}

function getEmptyTiped() {
  return {
    nombre: "",
    apellidos: "",
    email: "",
    telefono: "",
    alias: "",
    business: "",
  };
}

const calcularTasaFinal = (importe, tasa) => {
  if (!tasa || !importe) return 0;

  const tasaCalculada = parseFloat(((importe * tasa.percentage) / 100).toFixed(2));
  const min = tasa.minimumAmount || 0;
  const max = tasa.maximumAmount || Infinity;

  return Math.min(Math.max(tasaCalculada, min), max);
};


const FormScreen = () => {
  const [rating, setRating] = useState(3);
  const [comentario, setComentario] = useState("");
  const [tiper, setTiper] = useState({});
  const [landIn, setLandIn] = useState(new Date());
  const [tipeds, setTipeds] = useState([]);
  const [selectedTiped, setSelectedTiped] = useState(null);
  const [selectedTip, setSelectedTip] = useState(null);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [disable, setDisable] = useState(true);
  const [payFees, setPayFees] = useState(false);
  const navigate = useNavigate();
  const recipientId = useParams().id;
  const [business, setBusiness] = useState(getEmptyBusiness());
  const [tiped, setTiped] = useState(getEmptyTiped());
  const [propinaDirecta, setPropinaDirecta] = useState(false);
  const [tasa, setTasa] = useState({ percentage: 0, minimumAmount: 0, maximumAmount: 0, _id: "0" });
  const [tips, setTips] = useState([]);
  const [coin, setCoin] = useState({});
  const [textCookeis, setTextCoookies] = useState("");
  const [textLegal, setTextLegal] = useState("");
  const [ratingValue, setRatingValue] = useState(null);
  const [isFromBusiness, setIsFromBusiness] = useState(false);
  const [isFromTiped, setIsFromTiped] = useState(false);
  const [ratingsActive, setRatingsActive] = useState(false);
  
  useEffect(() => {
    event({
      action: "pantalla_vista",
      category: "Navegación",
      label: "Pantalla Inicial",
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const textResCookies = await getTextById("679c9c23474dd68f9a1080d9");
        if (textResCookies.status === 200) {
          setTextCoookies(textResCookies.data.content["es"]);
        }
        const textResLegal = await getTextById("679c9bb4474dd68f9a1080c6");
        if (textResLegal.status === 200) {
          setTextLegal(textResLegal.data.content["es"]);
        }
        const tasaRes = await getTasas();
        if (tasaRes.status === 200) {
          setTasa(
            tasaRes.data.length
              ? tasaRes.data.reduce((max, item) =>
                  new Date(item.createdAt) > new Date(max.createdAt)
                    ? item
                    : max
                )
              : {}
          );
        }
        //si es negocio, recipientId es el id del negocio, si es tiped, recipientId es el id del tiped
        const businessRes = await getBusinessByQrId(recipientId);
        if (businessRes.status === 200) {
          setIsFromBusiness(true);
          setIsFromTiped(false);
          const businessData = businessRes.data;
          const paisRes = await getPaisById(businessData.pais);
          await getLocalidadById(businessData.localidad).then((res) => {
            if (res.status === 200) {
              businessData.localidad = res.data.fullName;
            }
          });
          await getCategoriaEstablecimientoById(
            businessData.categoriaEstablecimiento
          ).then((res) => {
            if (res.status === 200) {
              businessData.categoriaEstablecimiento = res.data.name;
            }
          });
          if (paisRes.status === 200) {
            const coinsRes = await getCoinById(paisRes.data.coin);
            if (coinsRes.status === 200) {
              setTips(coinsRes.data.valores);
              setCoin(coinsRes.data);
            } else {
              throw new Error("No se pudo obtener la moneda.");
            }
          }
          try {
            const ratingRes = await getRatingByBusiness(businessData._id);
            if (ratingRes.status === 200) {
              setRatingValue(ratingRes.data.rating?.toFixed(1));
            }
          } catch (err) {
            console.warn("No se pudo obtener el rating del negocio:", err);
          }
          setBusiness(businessData);
          const tipedsRes = await getTipedsByBusinessId(businessData._id);
          if (tipedsRes.status === 200) {
            const activos = tipedsRes.data.filter((t) => t.active && !t.deleted);
            setTipeds(activos);
          }
          setPropinaDirecta(businessData.reparto.directa);
          setRatingsActive(businessData.ratingsActive);
        } else {
          const tipedRes = await getTipedByQrId(recipientId);
          if (tipedRes.status === 200) {
            setSelectedTiped(tipedRes.data);
            
            setIsFromBusiness(false);
            setIsFromTiped(true);
            const tipedData = tipedRes.data;
            const businessFromTiped = await getBusinessById(tipedData.business);
            if (businessFromTiped.status === 200) {
              const businessData = businessFromTiped.data;
              const paisRes = await getPaisById(businessData.pais);
              await getLocalidadById(businessData.localidad).then((res) => {
                if (res.status === 200) {
                  businessData.localidad = res.data.fullName;
                }
              });
              await getCategoriaEstablecimientoById(
                businessData.categoriaEstablecimiento
              ).then((res) => {
                if (res.status === 200) {
                  businessData.categoriaEstablecimiento = res.data.name;
                }
              });
              if (paisRes.status === 200) {
                const coinsRes = await getCoinById(paisRes.data.coin);
                if (coinsRes.status === 200) {
                  setTips(coinsRes.data.valores);
                  setCoin(coinsRes.data);
                } else {
                  throw new Error("No se pudo obtener la moneda.");
                }
              }
              try {
                const ratingRes = await getRatingByBusiness(businessData._id);
                if (ratingRes.status === 200) {
                  setRatingValue(ratingRes.data.rating?.toFixed(1));
                }
              } catch (err) {
                console.warn("No se pudo obtener el rating del negocio:", err);
              }
              setTiped(tipedData);
              setBusiness(businessData);
            }
          } else {
            throw new Error("No se pudo obtener el negocio ni tiped.");
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [recipientId]);

  const handleSubmit = async () => {
    if (!acceptTerms) {
      const params = {
        icon: "warning",
        iconHtml: "🥹",
        title: "Ooops...",
        text: "Por favor, marca el check de aceptación de los términos y condiciones",
      };
      Swal.fire(params);
    } else {
      const tasaAplicada = calcularTasaFinal(selectedTip?.import, tasa);

      let tip = {};
      tip.importe = selectedTip;
      tip.comentario = comentario;
      tip.rating = rating;
      tip.business = business._id;
      tip.landIn = landIn;
      tip.clickTerms = acceptTerms;
      tip.clickTaxes = payFees;
      tip.tiped = selectedTiped?._id;
      tip.tasa = tasa;

      const cookie = KTCookie.getCookie("tipifyCookie");
      if (!cookie) {
        await postTiper()
          .then((res) => {
            const options = {
              expires: new Date("9999-12-31T23:59:59.999Z"),
              path: "/",
            };
            KTCookie.setCookie("tipifyCookie", res.data.id, options);
            tip.tiper = res.data.id;
          })
          .catch((error) => console.log(error));
      } else {
        tip.tiper = cookie;
      }
      await postTip(tip)
        .then((res) => {
          navigate(`payout/${res.data.id}`);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <Container className="app-container">
      <div className="d-flex justify-content-center ">
        <div className="mt-3">
          <img src={logoSmall} alt="Logo" className="logo" />
        </div>
        <div className="d-flex justify-content-end">
          <div className="d-flex flex-column text-end mt-4">
            <div className="row d-flex align-items-center">
              <div className="col-md-12" style={{ fontSize: "23px" }}>
                {isFromTiped && (tiped.nombre ? tiped.nombre : '')} {tiped.alias ? '('+tiped.alias+')' : ''}
              </div>
              <div className="col-md-12" style={{ fontSize: "13px" }}>
                {business.categoriaEstablecimiento}
              </div>
              <div className="col-md-12">
                <FmdGoodOutlinedIcon className="me-1" />
                <strong style={{ fontSize: "13px" }}>
                  {business.nombre_comercial}
                </strong>
              </div>
              <div className="col-md-12 text-secondary adress">
                {business.direccion}, {business.codigo_postal}{" "}
                {business.localidad}
              </div>
              <div className="mt-1 d-flex align-items-center justify-content-end">
                <div className="d-flex align-items-center gap-2 px-1">
                  <span style={{ fontSize: "13px" }}> Valoración</span>
                  <StarIcon sx={{ color: "#ffb304", fontSize: "15px" }} />
                  <span className="text-secondary" style={{ fontSize: "13px" }}>
                  {ratingValue}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Estrellas */}
      {ratingsActive && <><div className="d-flex justify-content-center my-4">
        <div className="d-flex align-items-center gap-3">
          {[1, 2, 3, 4, 5].map((star) =>
            star <= rating ? (
              <StarIcon
                key={star}
                sx={{ color: "#ffb304", fontSize: "35px" }}
                onClick={() => {
                  event({
                    action: "click_star",
                    category: "Valoraciones",
                    label: "Pantalla Inicial",
                    value: star,
                  });
                  setRating(star)
                }}
              />
            ) : (
              <StarIcon
                key={star}
                sx={{ color: "#a0a4c1", fontSize: "35px" }}
                onClick={() => {
                  event({
                    action: "click_star",
                    category: "Valoraciones",
                    label: "Pantalla Inicial",
                    value: star,
                  });
                  setRating(star)
                }}
              />
            )
          )}
        </div>
      </div>

      <div className="d-flex flex-column align-items-center">
        <strong className="mb-2">Valora el servicio que te hemos dado</strong>
        <TextField
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          onChange={(e) => setComentario(e.target.value)}
          onBlur={(e) => {
            if (e.target.value.trim() !== "") {
              event({
                action: "escribir_comentario",
                category: "Opiniones",
                label: "Pantalla Inicial",
                value: e.target.value.length,
              });
            }
          }}
          placeholder="Cuéntanos qué te ha gustado🧡 y qué no… o qué te gustaría la próxima vez. ¡Tu opinión nos ayuda a mejorar!"
        />
      </div></>}

      {/* Propina */}
      <div className="d-flex flex-column align-items-center text-center">
        <strong className="mt-2 mb-2 ">¿Quieres dejar una propina {isFromTiped && <>a {tiped.nombre} {tiped.alias && <>({tiped.alias})</>}</>}?</strong>
        <span className="propina px-4">
          Elige el monto y daremos la propina a quien elijas
        </span>
        <div className="d-flex flex-wrap justify-content-center px-3">
          {tips.map((tip) => (
            <div
              key={tip.id}
              className="d-flex justify-content-center opciones"
              style={{ flexBasis: "33.33%" }} // Asegura que haya solo 3 elementos por fila
            >
              <Button
                variant={selectedTip?.id === tip.id ? "contained" : "outlined"}
                color="primary"
                onClick={() => {
                  event({
                    action: "select_tip_amount",
                    category: "Donaciones",
                    label: "Pantalla Inicial",
                    value: tip.import,
                  });
                  setSelectedTip(tip);
                  setDisable(false);
                }}
                style={{
                  backgroundColor:
                    selectedTip?.id === tip.id ? "#66bc5f" : "#bfbfbf",
                  fontSize: "20px",
                  fontWeight: selectedTip?.id === tip.id ? "bold" : "normal",
                  color: "white",
                  borderRadius: "10px",
                  border: "none",
                  boxShadow: "none",
                  height: "50px",
                  width: "75px",
                  padding: "0",
                }}
              >
                {tip.import.toLocaleString(coin.locale || "es-ES", {
                  style: "currency",
                  currency: coin.currency || "EUR",
                  maximumFractionDigits: 0,
                })}
              </Button>
            </div>
          ))}
        </div>
        {business.reparto.directa && isFromBusiness && (
          <div className="w-100">
            <FormControl variant="outlined" className="w-100">
              <Select
                value={selectedTiped ? selectedTiped._id : "none"}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selected = tipeds.find((t) => t._id === selectedId);

                  event({
                    action: "select_tiped",
                    category: "Propina Directa",
                    label: selected ? `${selected.nombre} ${selected.apellidos}` : "Equipo Completo",
                  });

                  setSelectedTiped(selectedId === "none" ? null : selected);
                }}
              >
                <MenuItem key="none" value="none">
                  Déjalo al equipo completo 🤝
                </MenuItem>
                {tipeds?.map((option) => (
                  <MenuItem key={option._id} value={option._id}>
                    {option.nombre} {option.apellidos} {option.alias && `(${option.alias})`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
      </div>

      {/* Checkboxes */}
      <div className="d-flex flex-column align-items-center">
        <div className="row d-flex align-items-center">
          <div className="col-md-12">
            <FormControlLabel
              control={
                <Checkbox
                  checked={payFees}
                  onChange={() => {
                    const newValue = !payFees;
                    event({
                      action: "toggle_pay_fees",
                      category: "Donaciones",
                      label: "Pantalla Inicial",
                      value: newValue ? 1 : 0,
                    });
                    setPayFees(newValue);
                  }}
                />
              }
              label={
                <span>
                  Contribuir con costes de transacción (+
                  {calcularTasaFinal(selectedTip?.import, tasa).toLocaleString(
                    coin.locale || "es-ES",
                    {
                      style: "currency",
                      currency: coin.currency || "EUR",
                    }
                  )}
                  ) <span className="heartbeat">💚</span>
                </span>
              }              
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "13px",
                  opacity: "0.75",
                },
              }}
            />
          </div>
          <div className="col-md-12">
            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                />
              }
              label={
                <span>
                  Acepto los{" "}
                  <a
                    href="#"
                    style={{
                      color: "#000",
                      opacity: "0.75",
                      textDecoration: "underline",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      event({
                        action: "open_terms_modal",
                        category: "Términos",
                        label: "Pantalla Inicial",
                        value: 1,
                      });
                      Swal.fire({
                        title: "Términos y Condiciones",
                        html: `
                          <div style="text-align: left; max-height: 50vh; overflow-y: auto;">
                            ${textLegal}
                          </div>
                        `,
                        width: 800,
                        showConfirmButton: true,
                        confirmButtonText: "Cerrar",
                        confirmButtonColor: "#66bc5f",
                      });
                    }}
                  >
                    términos y condiciones
                  </a>
                </span>
              }
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "13px",
                  opacity: "0.75",
                },
              }}
            />
          </div>
        </div>
      </div>
      <div className="d-flex flex-column align-items-center px-3 pb-3">
        <div className="col-md-12">
          {/* Botón Continuar */}
          <Button
            fullWidth
            variant="contained"
            disabled={disable}
            style={{
              backgroundColor: disable ? "#dff2de" : "#66bc5f",
              fontSize: "18px",
              color: disable ? "#888583" : "white",
              borderRadius: "30px",
              padding: "10px",
              width: "260px",
              textTransform: "none",
              border: disable ? "1px solid #888583" : "none",
            }}
            onClick={() => {
              event({
                action: "click_continuar",
                category: "Formulario",
                label: "Pantalla Inicial",
              });
              handleSubmit();
            }}
          >
            Continuar
          </Button>
        </div>
      </div>
      <CookieConsent
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          textAlign: "left",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          height: "fit-content",
          display: "flex !important",
          flexDirection: "column !important",
          alignItems: "center !important",
        }}
        buttonStyle={{
          backgroundColor: "#66bc5f",
          color: "#fff",
          fontSize: "16px",
          padding: "15px",
          width: "40%",
        }}
        declineButtonStyle={{
          backgroundColor: "transparent",
          color: "#fff",
          fontSize: "15px",
          border: "2px solid #aaa",
          cursor: "pointer",
          opacity: 0.6,
          padding: "15px",
          width: "40%",
        }}
        buttonWrapperClasses="container-botones"
        enableDeclineButton
        cookieName="myAwesomeCookieName3"
        expires={999}
        buttonText="Aceptar"
        declineButtonText="Rechazar"
        overlay
        onAccept={() => {
          event({
            action: "cookies_aceptadas",
            category: "Cookies",
            label: "Consentimiento",
            value: 1,
          });
        }}
        onDecline={() => {
          event({
            action: "cookies_rechazadas",
            category: "Cookies",
            label: "Consentimiento",
            value: 0,
          });
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: textCookeis }} />
        <a
          href="/politica-cookies"
          style={{ color: "#fff", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Leer más
        </a>
      </CookieConsent>
    </Container>
  );
};

export default FormScreen;
